export const Fade = `
-webkit-animation: fade 0.6s ease-out;
animation: fade 0.6s ease-out;
@keyframes fade {
from {
opacity: 0;
}
to {
opacity: 1;
}
}
`;

export const FadeInEntrances = `
-webkit-animation: fade-in 0.6s cubic-bezier(0.390, 0.575, 0.565, 1.000) 0.6s both;
animation: fade-in 0.6s cubic-bezier(0.390, 0.575, 0.565, 1.000) 0.6s both;
@-webkit-keyframes fade-in {
0% {
  opacity: 0;
}
100% {
  opacity: 1;
}
}
@keyframes fade-in {
0% {
  opacity: 0;
}
100% {
  opacity: 1;
}
}
`;

export const SlideOutLeft = `
-webkit-animation: slide-out-left 0.5s cubic-bezier(0.550, 0.085, 0.680, 0.530) both;
animation: slide-out-left 0.5s cubic-bezier(0.550, 0.085, 0.680, 0.530) both;
@-webkit-keyframes slide-out-left {
0% {
-webkit-transform: translateX(0);
transform: translateX(0);
opacity: 1;
}
100% {
-webkit-transform: translateX(-1000px);
transform: translateX(-1000px);
opacity: 0;
}
}
@keyframes slide-out-left {
0% {
-webkit-transform: translateX(0);
transform: translateX(0);
opacity: 1;
}
100% {
-webkit-transform: translateX(-1000px);
transform: translateX(-1000px);
opacity: 0;
}
}
`;

export const SlideInLeft = `
-webkit-animation: slide-left 0.3s cubic-bezier(0.680, -0.550, 0.265, 1.550) both;
animation: slide-left 0.3s cubic-bezier(0.680, -0.550, 0.265, 1.550) both;
@-webkit-keyframes slide-left {
0% {
-webkit-transform: translateX(100px);
transform: translateX(100px);
}
100% {
-webkit-transform: translateX(0);
transform: translateX(0);
}
}
@keyframes slide-left {
0% {
-webkit-transform: translateX(100px);
transform: translateX(100px);
}
100% {
-webkit-transform: translateX(0);
transform: translateX(0);
}
}
`;
